import type { CityConfig } from "../city-template/types";

export const indianapolisConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Indianapolis",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "indianapolis",
  route: "/cities/indianapolis",
  title: "Emergency Passport Indianapolis, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Indianapolis, IN — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Indianapolis, Carmel, Fishers, Noblesville, Greenwood, and Central Indiana. Indy 500, NCAA, Eli Lilly, and corporate travel expertise.",
  h1: "Emergency & Expedited Passport Services in Indianapolis, IN",
  heroSubtitle: "Indy 500 trip to Monaco Grand Prix in two weeks? NCAA Final Four business trip to London on short notice? Eli Lilly or Salesforce corporate travel to Tokyo? We help Indianapolis residents — from downtown professionals to Carmel families to Fishers tech workers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20Indianapolis%20Indiana%20skyline%20with%20the%20Soldiers%20and%20Sailors%20Monument%20and%20modern%20glass%20skyscrapers%2C%20White%20River%20State%20Park%20visible%20in%20the%20foreground%2C%20warm%20golden%20sunset%20light%2C%20professional%20city%20photography%2C%20clean%20and%20vibrant%20downtown%20atmosphere%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography%20with%20warm%20tones%20and%20architectural%20details&width=1800&height=700&seq=indianapolis-hero-2026&orientation=landscape",
  heroImageAlt: "Indianapolis Indiana skyline with Soldiers and Sailors Monument and downtown skyscrapers",
  geoPosition: "39.7684;-86.1581",
  geoPlacename: "Indianapolis, Indiana",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 180 miles from Indianapolis — about 3 hours via I-65",
  },
  nearbyCitiesZips: [
    { name: "Indianapolis", zips: "46201–46290" },
    { name: "Carmel", zips: "46032, 46033, 46074, 46082" },
    { name: "Fishers", zips: "46037, 46038, 46040, 46085" },
    { name: "Noblesville", zips: "46060, 46061, 46062" },
    { name: "Greenwood", zips: "46142, 46143, 46184" },
    { name: "Westfield", zips: "46033, 46074, 46075" },
    { name: "Zionsville", zips: "46077, 46068" },
    { name: "Avon", zips: "46123, 46234" },
    { name: "Plainfield", zips: "46168, 46122, 46234" },
    { name: "Brownsburg", zips: "46112" },
    { name: "Lawrence", zips: "46226, 46236, 46256" },
    { name: "Beech Grove", zips: "46107" },
    { name: "Speedway", zips: "46224, 46214" },
    { name: "Franklin", zips: "46131" },
    { name: "Greenfield", zips: "46140" },
    { name: "Anderson", zips: "46011–46018" },
    { name: "Muncie", zips: "47302–47308" },
    { name: "Terre Haute", zips: "47801–47809" },
    { name: "Lafayette", zips: "47901–47909" },
    { name: "Bloomington", zips: "47401–47408" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Chicago Passport Agency — as fast as 24 hours for Hoosier travelers with immediate departures." },
    { icon: "ri-trophy-line", title: "Sports & Event Travel Ready", desc: "Indy 500, Brickyard 400, NCAA Final Four, Big Ten Championship — we know sports travel timelines and last-minute booking dynamics." },
    { icon: "ri-building-2-line", title: "Corporate & Pharma Travel", desc: "Eli Lilly, Salesforce, Roche Diagnostics, Anthem — we handle the passport so Indianapolis professionals handle the business." },
    { icon: "ri-graduation-cap-line", title: "University & Academic Travel", desc: "IUPUI, Butler, UIndy, Purdue-Indianapolis students and faculty studying and presenting abroad — we meet academic deadlines." },
  ],
  internalLinks: [
    { name: "Expedited passport in Carmel, IN", route: "/cities/carmel" },
    { name: "Fast passport services in Fort Wayne, IN", route: "/fort-wayne" },
    { name: "Quick passport services in Evansville, IN", route: "/evansville" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeAddress: "1 American Square, Indianapolis, IN 46282",
  officePhone: "(877) 253-0084",
  officeHours: [
    { days: "Monday – Friday", hours: "9:00 AM – 6:00 PM EST" },
    { days: "Saturday", hours: "10:00 AM – 2:00 PM EST" },
    { days: "Sunday", hours: "Closed" },
  ],
  fpcOfficeNote: "Visit the Fast Passport Center office at 1 American Square in downtown Indianapolis by appointment only. Sign up on our website first to schedule your visit — walk-ins are not accepted. We offer full-service expedited and emergency passport processing for Indianapolis and Central Indiana travelers.",
  fpcOfficeDistance: "Located in downtown Indianapolis — serving Carmel, Fishers, Noblesville, Greenwood, and all Central Indiana",
  mapEmbedUrl: "https://www.google.com/maps?q=1+American+Square,+Indianapolis,+IN+46282&output=embed",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Indianapolis and Central Indiana. From downtown Indy near Monument Circle and the Convention Center to the northern suburbs of Carmel and Fishers, from Greenwood and Franklin to the south to Zionsville and Brownsburg to the west — we serve all of Marion County, Hamilton County, Johnson County, and beyond. Our courier service eliminates the need to compete for scarce agency appointments at the Chicago Passport Agency.",
  nearbyCitiesIntro: "We serve Indianapolis and all Central Indiana communities including Carmel, Fishers, Noblesville, Greenwood, Westfield, Zionsville, Avon, Plainfield, Brownsburg, Lawrence, Beech Grove, Speedway, Franklin, Greenfield, Anderson, Muncie, Terre Haute, Lafayette, and Bloomington. We also serve travelers departing from Indianapolis International Airport (IND) who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Indianapolis as simple as possible — with the efficiency and reliability that Hoosier professionals, sports travelers, and Central Indiana families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Indianapolis travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Indianapolis travelers encounter unique passport issues — from Indy 500 international travel to NCAA tournament business trips to Eli Lilly global conference deadlines. Here are the most common passport mistakes we see from Central Indiana.",
  testimonialsIntro: "Indianapolis travelers — from downtown professionals to Carmel families to Fishers tech workers — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Indianapolis, IN? Here are the most common ones we hear from Central Indiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  servicesIntro: "Whether you need a renewal before an IND international flight, an emergency passport for a last-minute corporate trip, or a first-time passport for a Central Indiana family vacation — Fast Passport Center handles it with reserved courier submission availability and direct Chicago Passport Agency access. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct Chicago Passport Agency access", "Only city in Indiana with a local agency", "Predictable turnaround", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Chicago Passport Agency serves all of Indiana — appointments scarce", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "IND flight to London in two days? International business trip to Tokyo this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Indianapolis-area travelers.",
      bullets: ["As fast as 24 hours", "Direct Chicago Passport Agency access", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Indianapolis residents renew fast — no agency visit required for most renewals. Perfect for downtown professionals, Carmel families, and Fishers tech workers preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Indianapolis residents through every step — from downtown to Carmel to Greenwood — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your IND international connection or business trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Central Indiana family vacation or sports trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Indianapolis professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Eli Lilly executives, Salesforce consultants, and motorsports professionals who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Central Indiana travelers through the process so your international itinerary or corporate travel stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Popular with Indianapolis travelers driving to Windsor, ON for weekend trips.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Indianapolis IN", description: "Urgent passport processing for Indianapolis Indiana travelers with immediate departure needs from IND Airport." },
    { name: "Expedited Passport Renewal Indianapolis IN", description: "Fast passport renewal for Indianapolis Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Indianapolis IN", description: "New passport application services for Indianapolis Indiana residents applying for their first passport." },
    { name: "Child Passport Indianapolis IN", description: "Minor passport services for Indianapolis Indiana families with children under 16." },
    { name: "Name Change Passport Indianapolis IN", description: "Passport name correction after marriage, divorce, or legal name changes for Indianapolis residents." },
    { name: "Second Passport Indianapolis IN", description: "Second passport services for Indianapolis corporate executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Dr. Michael T.",
      location: "Carmel, IN",
      rating: 5,
      text: "Conference in Geneva in 4 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. The Chicago Passport Agency is literally in our city — this service is a game changer. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Jennifer K.",
      location: "Fishers, IN",
      rating: 5,
      text: "Family trip to Cancun with 10 days notice. Four passports — two renewals and two first-time for our kids. Done in 4 days. We shipped from FedEx on Keystone and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "David R.",
      location: "Indianapolis, IN",
      rating: 5,
      text: "Business trip to London with 8 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. Being able to hand-deliver to the Chicago Passport Agency is a huge advantage.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah L.",
      location: "Greenwood, IN",
      rating: 5,
      text: "Lost my passport the week before a study abroad semester in Italy. Fast Passport Center replaced it in 48 hours. As an IUPUI student, I couldn't afford to miss my program. They saved my semester.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "indy-1",
      name: "Indianapolis Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 N Alabama St",
      city: "Indianapolis",
      state: "IN",
      zip: "46204",
      phone: "(317) 631-5551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Indianapolis, near Circle Centre",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Indianapolis acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers and IUPUI campus.",
      icon: "ri-mail-line",
    },
    {
      id: "indy-2",
      name: "Carmel Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2750 E 146th St",
      city: "Carmel",
      state: "IN",
      zip: "46033",
      phone: "(317) 846-3504",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Carmel, approximately 20 miles north of downtown Indianapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Carmel, Fishers, and northern Hamilton County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "indy-3",
      name: "Greenwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "167 W Main St",
      city: "Greenwood",
      state: "IN",
      zip: "46142",
      phone: "(317) 888-2234",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Greenwood, approximately 12 miles south of downtown Indianapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Greenwood, Franklin, and southern Johnson County residents. Good alternative for south-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "indy-4",
      name: "Fishers Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11601 Municipal Dr",
      city: "Fishers",
      state: "IN",
      zip: "46038",
      phone: "(317) 579-5251",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fishers, approximately 18 miles northeast of downtown Indianapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Fishers and northeastern Hamilton County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "indy-5",
      name: "Marion County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "200 E Washington St",
      city: "Indianapolis",
      state: "IN",
      zip: "46204",
      phone: "(317) 327-4010",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Indianapolis City-County Building",
      website: "https://www.indy.gov/agency/marion-county-clerk",
      websiteLabel: "Marion County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "indy-6",
      name: "Westfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17535 Dartown Rd",
      city: "Westfield",
      state: "IN",
      zip: "46074",
      phone: "(317) 896-5004",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Westfield, approximately 25 miles north of downtown Indianapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Westfield and northern Hamilton County residents. Newer facility with good appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — visit Chicago Passport Agency on Indiana Avenue", fpc: "Most Central Indiana travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Indy-Specific Guidance", agency: "Generic — no sports, pharma, or Central Indiana expertise", fpc: "Full Indianapolis sports/corporate/university knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming the Indy Agency Takes Walk-Ins",
      description: "The Chicago Passport Agency at 230 S Dearborn St Suite 380, Chicago IL 60604nue requires appointments even for emergencies. Many Hoosiers arrive without an appointment and are turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Indianapolis applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Indy 500 Season Passport Rush",
      description: "May in Indianapolis is not just about the 500 — it's peak passport demand season. Post office appointments fill 3+ weeks out during race month. If traveling internationally before or after race season, start early.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Central Indiana families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Indianapolis travelers booking to Japan, Southeast Asia, or Europe often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or a Mass Ave coffee shop." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Indianapolis clients ship from home or a nearby UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved Chicago Passport Agency availability — so you do not have to compete for scarce public appointments at the Indiana Avenue agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Indianapolis?", a: "We offer Indianapolis-area clients expedited processing as fast as 24 hours through our registered courier service to the Chicago Passport Agency. Standard expedited service typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Does Indianapolis have its own passport agency?", a: "Yes — Indianapolis is the only city in Indiana with a regional passport agency. The Chicago Passport Agency is at 230 S Dearborn St Suite 380, Chicago IL 60604. This gives Indy-area travelers a significant advantage over Fort Wayne, Evansville, and South Bend residents who would need to travel to Chicago or Detroit for emergency in-person service." },
    { q: "Do I need to visit an Indianapolis office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (an Indianapolis post office or Marion County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Indianapolis address." },
    { q: "Where can I get a passport acceptance in Indianapolis?", a: "Indianapolis has acceptance facilities at the Main Post Office (150 N Alabama St), Carmel Post Office, Fishers Post Office, Greenwood Post Office, Marion County Clerk (200 E Washington St), and Westfield Post Office. We maintain an updated list with hours, photo availability, and appointment options." },
    { q: "What is the best price for expedited passport service in Indianapolis?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Does Fast Passport Center serve Eli Lilly and Salesforce employees?", a: "Yes. Fast Passport Center serves all of Central Indiana including major corporate campuses. We understand international business travel deadlines and conference schedules. Our Chicago Passport Agency access is especially valuable for last-minute corporate travel needs." },
    { q: "Can you help with passports during Indy 500 season?", a: "Absolutely. May is peak passport demand in Indianapolis — between race fans traveling internationally, corporate hospitality events, and summer travel planning. Post office appointments book 3+ weeks out. Our courier service operates independently of public appointment availability, so race season timing is never an issue." },
    { q: "What airports do Indianapolis travelers typically use?", a: "Indianapolis International Airport (IND) is the primary airport. It offers direct flights to Toronto, Cancun, and Paris (seasonal) with connecting service worldwide. Some Indianapolis travelers also use Chicago O'Hare (ORD) for more international options — about 3 hours northwest." },
    { q: "How do I check my Indianapolis passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Indianapolis to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help IUPUI or Butler students with study abroad passports?", a: "Yes. We help IUPUI, Butler, UIndy, and Purdue-Indianapolis students every semester with study abroad passport applications and renewals. Our team knows the tight deadlines study abroad programs impose and can process your passport fast enough to meet application requirements." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Indianapolis Residents",
    intro: "Indianapolis is Indiana's only city with a regional passport agency — a massive advantage. But the city's sports tourism dominance, pharmaceutical industry, and growing tech sector create unique passport timing pressures. Here's what Hoosier travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "IND — Indianapolis International Airport",
        subtitle: "Central Indiana's international gateway",
        description: "Indianapolis International Airport (IND) serves over 9 million passengers annually with direct flights to Toronto, Cancun, and seasonal Paris service, plus connecting flights worldwide through major hubs. IND consistently ranks among America's best airports for passenger experience. The airport's central location — reachable from downtown in 15 minutes and from Carmel/Fishers in 30 minutes — makes spontaneous international trips increasingly common. Delta's seasonal Paris nonstop creates a steady stream of passport urgencies when travelers book months ahead and discover expired passports at check-in.",
        tip: "Delta's IND-Paris route requires 6-month passport validity beyond return date for Schengen zone entry. Verify passport validity the moment you book — not when you pack. IND's international check-in desks are strict on this requirement.",
      },
      {
        icon: "ri-trophy-line",
        title: "Sports Tourism & International Event Travel",
        subtitle: "Indy 500, Brickyard 400, NCAA Final Four, Big Ten Championship",
        description: "Indianapolis is the sports capital of the Midwest. The Indy 500 alone draws 300,000+ fans, and many extend their trip internationally — to the Monaco Grand Prix, Le Mans, or European Formula 1 circuits. NCAA Final Four and Big Ten Championship events bring national audiences who often combine business with international travel. The Indianapolis Motor Speedway's global partnerships with F1 circuits and international racing series create regular travel demand for motorsports professionals with 1–3 week booking windows.",
        tip: "Motorsports professionals traveling to European F1 races or Asian racing circuits should maintain a second passport. Visa processing for certain countries can take 4–8 weeks, leaving the primary passport unavailable for other travel.",
      },
      {
        icon: "ri-building-2-line",
        title: "Pharma & Life Sciences Corporate Travel",
        subtitle: "Eli Lilly, Roche Diagnostics, Anthem, Corteva",
        description: "Indianapolis is a global pharmaceutical and life sciences hub. Eli Lilly alone employs over 10,000 people locally and sends executives, researchers, and sales teams to facilities and conferences worldwide. Roche Diagnostics' North American headquarters in Indianapolis generates regular travel to Switzerland and Germany. When FDA submissions, clinical trial milestones, or acquisition deadlines create sudden international travel needs, standard passport processing is simply not an option.",
        tip: "Pharma executives and researchers should check passport validity quarterly — not just before trips. Many international conferences and regulatory meetings have fixed dates with no flexibility for passport-related delays. Fast Passport Center can process in 2–9 business days for planned trips and 24 hours for emergencies.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "University Research & Academic Travel",
        subtitle: "IUPUI, Butler, UIndy, Marian, Purdue-Indianapolis",
        description: "Indianapolis universities send hundreds of students and faculty abroad annually. IUPUI's robust international programs — particularly in health sciences, engineering, and public health — create regular demand for expedited passports. Butler University's study abroad programs in Europe and Asia have 8–12 week acceptance-to-departure pipelines. IU School of Medicine researchers present at international conferences in Geneva, Barcelona, and Tokyo with 2–4 week notice. The university calendar creates predictable surge periods in August–September and January–February.",
        tip: "IUPUI and Butler study abroad students should apply for passports immediately upon program acceptance. The 6–10 week window between acceptance and departure is tight for standard processing but comfortable for expedited courier service.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Indy's Passport Agency — Indiana's Only One",
      description: "Indianapolis is the only Indiana city with a regional passport agency — located at 230 S Dearborn St Suite 380, Chicago IL 60604. While the agency serves life-or-death emergencies by appointment only, our registered courier channel provides faster, more accessible processing for Indianapolis residents' routine and urgent needs without the appointment lottery. This local agency advantage means Indianapolis travelers get the fastest possible turnaround of any Indiana city.",
    },
  },
  destinations: {
    title: "Where Indianapolis Travelers Go — And Why Passports Get Urgent",
    intro: "Indy's global sports connections, pharmaceutical industry, and university networks send travelers worldwide. Here are the most common international destinations and urgency patterns.",
    stats: [
      { stat: "40%", label: "of Indianapolis expedited requests are corporate/pharma-related with under 2 weeks notice" },
      { stat: "2–3 Weeks", label: "average lead time Indianapolis travelers have from trip booking to international departure" },
      { stat: "Mar–Jun", label: "peak season when Indy 500, NCAA tournaments, summer travel, and pharma conference season collide" },
      { stat: "26 Hours", label: "shortest turnaround we have accommodated for an Indianapolis executive departing to London" },
    ],
    destinations: [
      { name: "United Kingdom", context: "IND connecting flights to London, Eli Lilly UK operations, motorsports connections to Silverstone and Goodwood, Butler study abroad programs", urgency: "Business and motorsports trips booked 1–2 weeks out; 6-month validity required", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Eli Lilly and Roche Asia-Pacific operations, automotive supplier visits (Subaru, Toyota Indiana connections), Indy 500 driver connections to Japanese motorsports", urgency: "Pharma and automotive travel booked 1–2 weeks out; Japan requires 6-month validity", icon: "ri-map-pin-2-line" },
      { name: "Germany & Switzerland", context: "Roche Diagnostics HQ connections (Basel and Mannheim), pharmaceutical conferences, automotive manufacturing supplier visits, Lilly European operations", urgency: "Pharma industry conference dates are fixed and unmovable", icon: "ri-map-pin-2-line" },
      { name: "France & Italy", context: "IND seasonal nonstop to Paris, IUPUI and Butler study abroad, motorsports travel to Le Mans and Monza, pharma conferences", urgency: "Study abroad deadlines and conference dates create compressed timelines", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "IND-Cancun direct flights, spring break, destination weddings, all-inclusive resort packages", urgency: "Spring break bookings peak January through March", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Toronto business travel, cross-border pharmaceutical partnerships, weekend trips to Windsor and Niagara Falls", urgency: "Cross-border business bookings often 1–2 weeks out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Indiana Service Areas",
    crossLinksDesc: "We serve travelers across the Hoosier State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Fort Wayne", route: "/fort-wayne" },
      { name: "Evansville", route: "/evansville" },
      { name: "Carmel", route: "/cities/carmel" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Meridian Indianapolis", address: "5350 N Meridian St, Indianapolis, IN 46208", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Walgreens — Castleton", address: "8235 Center Run Dr, Indianapolis, IN 46250", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "UPS Store — Carmel", address: "14100 N River Rd, Carmel, IN 46033", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "FedEx Office — Downtown Indianapolis", address: "1 N Pennsylvania St, Indianapolis, IN 46204", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html" },
    { name: "CVS — Fishers", address: "11681 Brooks School Rd, Fishers, IN 46037", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walmart — Greenwood", address: "882 S State Road 135, Greenwood, IN 46143", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
  ],
  dmvLocations: [
    {
      name: "Indiana BMV — Indianapolis South",
      address: "1414 W Morris St, Indianapolis, IN 46221",
      hours: "Mon–Fri: 8:30AM–6:00PM",
      note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended.",
      featured: true,
    },
    {
      name: "Indiana BMV — Carmel",
      address: "14560 River Rd, Carmel, IN 46033",
      hours: "Mon–Fri: 8:30AM–6:00PM",
      note: "Serves Carmel, Fishers, and northern Hamilton County. Full REAL ID processing available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "7 miles southwest of downtown Indianapolis via I-70",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary airport for Indianapolis and Central Indiana. Direct flights to Toronto, Cancun, and Paris (seasonal). Connecting service worldwide through major hubs.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 3 hours northwest of Indianapolis via I-65",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major hub for Indianapolis travelers seeking more international routes. United and American Airlines hub with global connections.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International Airport",
      distance: "Approximately 2 hours southeast of Indianapolis via I-74",
      address: "2939 Terminal Dr, Hebron, KY 41048",
      note: "Alternative airport for Indianapolis travelers. Delta hub with domestic and international connections.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Indiana Department of Health Vital Records office. Online, mail, or in-person options available for Marion County and all Indiana counties.",
      url: "https://www.in.gov/health/vital-records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Indiana Vital Records. Required for estate and legal matters in Marion County.",
      url: "https://www.in.gov/health/vital-records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Marion County Clerk at 200 E Washington St. Certified copies for name changes and passport applications.",
      url: "https://www.indy.gov/agency/marion-county-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Marion County Clerk of Courts. Required for name change passport corrections.",
      url: "https://www.indy.gov/agency/marion-county-clerk",
    },
  ],
};